import SEO from "@/components/SEO";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import AboutSection from "@/components/AboutSection";
import Services from "@/components/Services";
import AgentCard from "@/components/AgentCard";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Resources from "@/components/Resources";

import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Samran Real Estate | Central Valley Farm & Land Specialist"
        description="Buy, sell, and manage farmland in California's Central Valley. Gurbir Samran specializes in almond and pistachio orchards across Merced, Madera, and Fresno counties."
        path="/"
      />
      <Navigation />
      <Hero />
      <AboutSection />
      <Services />
      <AgentCard />
      <Testimonials />
      <Resources />
      <FAQ />

      <Contact />
      <Footer />
    </div>
  );
};

export default Index;
